/**
 * Created by Rodrigo Quesada on 16/03/17.
 */
import {NgModule} from '@angular/core';
import {PageCommonModule} from '../../shared/page-common.module';
import {CvDownloadSectionService} from './model/cv-download-section.service';
import {CvDownloadPageComponent} from './cv-download-page.component';
import {CvDocument} from './document/cv-document.class';
import {LicensesAndCertificationsInfo} from './document/licenses-and-certifications.class';

@NgModule({
    imports: [PageCommonModule],
    declarations: [CvDownloadPageComponent],
    providers: [CvDownloadSectionService, CvDocument.InjectedMembers, LicensesAndCertificationsInfo.InjectedMembers]
})
export class CvDownloadPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/cv-download-page.module.ts